
import { Droppable } from "@hello-pangea/dnd";
import TaskCard from "./TaskCard";
import { useNavigate } from "react-router-dom";
const COLORS = {
  TODO: "from-blue-400 to-blue-600",
  IN_PROGRESS: "from-yellow-400 to-yellow-600",
  REVIEW: "from-purple-400 to-purple-600",
  HOLD: "from-red-400 to-red-600",
  DONE: "from-green-400 to-green-600",
};
 
export default function TaskColumn({ title, status, tasks, onTaskClick ,  isMyView}) {
 
  const navigate = useNavigate();
  return (
    <Droppable droppableId={status}>
      {(provided) => (
        <div ref={provided.innerRef} {...provided.droppableProps}
          className="bg-white rounded-2xl p-5 shadow-xl flex flex-col min-h-[350px]">
 
          <div className={`bg-gradient-to-r ${COLORS[status]} text-white rounded-xl p-3 mb-4`}>
            <div className="flex justify-between items-center">
              <h3 className="font-semibold">{title}</h3>
              <span className="text-xs bg-white/30 px-2 py-1 rounded-full">
                {tasks.length}
              </span>
            </div>
          </div>
 
          {/* <div className="bg-gray-50 rounded-xl p-3 flex-1 flex flex-col gap-4 overflow-y-auto max-h-[650px]"> */}
           
          <div className="bg-gray-50 rounded-xl p-3 flex-1 flex flex-col gap-4 overflow-y-auto max-h-[420px] no-scrollbar">
 
{tasks.length === 0 ? (
  <div className="flex-1 flex items-center justify-center text-sm text-gray-400 italic">
    Drop tasks here
  </div>
) : (
  <>
    {tasks.slice(0, 5).map((task, index) => (
      <TaskCard
        key={task.id}
        task={task}
        index={index}
        onClick={() => onTaskClick(task)}
        compact={isMyView}
      />
    ))}
 
    {/* ✅ VIEW ALL BUTTON */}
    {tasks.length > 5 && (
      <button
        onClick={() => {
          const user = JSON.parse(localStorage.getItem("user") || "{}");
          const roleId = Number(user?.role_id);
          const isAdminOrHR = roleId === 1 || roleId === 2;

          if (isAdminOrHR) {
            navigate("/profile", { state: { tab: "task" } });
          } else {
            navigate("/tasks/all");
          }
        }}
        className="mt-2 text-sm text-blue-600 hover:underline text-center w-full"
      >
        View All ({tasks.length})
      </button>
    )}
  </>
)}
</div>
     
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}
 



// import { Droppable } from "@hello-pangea/dnd";
// import TaskCard from "./TaskCard";
// import { useNavigate } from "react-router-dom";
// const COLORS = {
//   TODO: "from-blue-400 to-blue-600",
//   IN_PROGRESS: "from-yellow-400 to-yellow-600",
//   REVIEW: "from-purple-400 to-purple-600",
//   BLOCKED: "from-red-400 to-red-600",
//   DONE: "from-green-400 to-green-600",
// };

// export default function TaskColumn({ title, status, tasks, onTaskClick ,  isMyView}) {

//   const navigate = useNavigate();
//   return (
//     <Droppable droppableId={status}>
//       {(provided) => (
//         <div ref={provided.innerRef} {...provided.droppableProps}
//           className="bg-white rounded-2xl p-5 shadow-xl flex flex-col min-h-[350px]">

//           <div className={`bg-gradient-to-r ${COLORS[status]} text-white rounded-xl p-3 mb-4`}>
//             <div className="flex justify-between items-center">
//               <h3 className="font-semibold">{title}</h3>
//               <span className="text-xs bg-white/30 px-2 py-1 rounded-full">
//                 {tasks.length}
//               </span>
//             </div>
//           </div>

//           {/* <div className="bg-gray-50 rounded-xl p-3 flex-1 flex flex-col gap-4 overflow-y-auto max-h-[650px]"> */}
            
//           <div className="bg-gray-50 rounded-xl p-3 flex-1 flex flex-col gap-4 overflow-y-auto max-h-[420px] no-scrollbar">

// {tasks.length === 0 ? (
//   <div className="flex-1 flex items-center justify-center text-sm text-gray-400 italic">
//     Drop tasks here
//   </div>
// ) : (
//   <>
//     {tasks.slice(0, 5).map((task, index) => (
//       <TaskCard
//         key={task.id}
//         task={task}
//         index={index}
//         onClick={() => onTaskClick(task)}
//         compact={isMyView}
//       />
//     ))}

//     {/* ✅ VIEW ALL BUTTON */}
//     {tasks.length > 5 && (
//       <button
//         // onClick={() => window.location.href = "/"}
//         onClick={() =>
//           navigate("/", {
//             state: { scrollTo: "auto" }
//           })
//         }
//         className="mt-2 text-sm text-blue-600 hover:underline text-center"
//       >
//         View All ({tasks.length})
//       </button>
//     )}
//   </>
// )}
// </div>
//           {/* <div className="bg-gray-50 rounded-xl p-3 flex-1 flex flex-col gap-4 overflow-y-auto max-h-[420px] no-scrollbar">
//             {tasks.length === 0 ? (
//               <div className="flex-1 flex items-center justify-center text-sm text-gray-400 italic">
//                 Drop tasks here
//               </div>
//             ) : (
//               tasks.map((task, index) => (
//                 <TaskCard
//                   key={task.id}
//                   task={task}
//                   index={index}
//                   onClick={() => onTaskClick(task)}
//                   compact={isMyView}   // 👈 ADD THIS
                  
//                 />
//               ))
//             )}
//           </div> */}

//           {provided.placeholder}
//         </div>
//       )}
//     </Droppable>
//   );
// }
